import { Injectable, Type } from '@angular/core';

import { DynamicElements } from '../data/dynamic-elements.data';
import { DynamicElementService } from '../models/dynamic';
import { AnyDynamicElement } from '../models/dynamic/dynamic-element.model';
import { DynamicComponent } from '../types/dynamic-component.type';

@Injectable({
    providedIn: 'root',
})
export class DynamicElementDefaultService implements DynamicElementService {
    private _components = new Map<string, Type<AnyDynamicElement>>();

    constructor() {
        this.addComponents(DynamicElements.components);
    }

    getComponent(name: string): DynamicComponent {
        const dynamicComponent = this._components.get(name);
        if (!dynamicComponent) {
            throw new Error(`Component of type ${name} does not exist`);
        }
        return {
            component: dynamicComponent,
            type: name,
        };
    }

    public addComponents(components: { [key: string]: Type<AnyDynamicElement> }[]) {
        components.forEach((component) => {
            Object.entries(component).forEach(([type, value]) => {
                if (this._components.has(type))
                    throw new Error(`A component with this type: ${type}, already exists`);
                this._components.set(type, value);
            });
        });
    }
}
